/**
 * EDITABLE INPUT CELL
 * Cellule avec input éditable (texte ou date)
 */

import { useEffect, useState } from 'react';

interface EditableInputCellProps {
  value: string;
  type?: 'text' | 'date';
  onSave: (newValue: string) => void;
  readOnly?: boolean; // Si true, l'input est en lecture seule
}

export function EditableInputCell({
  value,
  type = 'text',
  onSave,
  readOnly = false,
}: EditableInputCellProps) {
  const [_isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  function handleBlur() {
    if (readOnly) return;
    setIsEditing(false);
    if (currentValue !== value) {
      onSave(currentValue);
    }
  }

  function handleKeyDown(e: React.KeyboardEvent) {
    if (readOnly) return;
    if (e.key === 'Enter') {
      handleBlur();
    } else if (e.key === 'Escape') {
      setCurrentValue(value);
      setIsEditing(false);
    }
  }

  // Pour les dates, on utilise un input natif type="date" qui gère le format localement
  const displayValue =
    type === 'date' ? (currentValue ? currentValue.split('T')[0] : '') : currentValue;

  return (
    <div className="flex flex-col flex-grow min-w-0">
      <div className="relative w-full h-9 bg-white rounded-md border border-zinc-200 shadow-xs">
        <input
          type={type}
          value={displayValue}
          onChange={(e) => !readOnly && setCurrentValue(e.target.value)}
          onFocus={() => !readOnly && setIsEditing(true)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          readOnly={readOnly}
          className={`w-full h-full px-3 py-1 text-table-cell text-zinc-900 bg-transparent border-none outline-none truncate ${readOnly ? 'cursor-default' : 'cursor-text'}`}
          placeholder={type === 'date' ? 'DD/MM/YYYY' : ''}
        />
      </div>
    </div>
  );
}
